import { gql } from "@apollo/client"
import { JOB_STEP_FIELDS } from "./jobStepFieldsFragment"

/**
 * Important: Be very careful adding fields to this fragment. It's very important that it stays lightweight.
 */
const JOB_LIST_FIELDS = gql`
  fragment JobListFields on Job {
    id
    type
    title
    process {
      id
      inactive
      name
    }
    parent {
      job
    }
    availableFrom
    dueAt
    isOverdue @client
    isHistorical @client
    availableUntil {
      type
      at
    }
    scheduleName
    processName
    displayName
    repeat {
      type
      frequency
      weekdays {
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
      }
    }
    adhoc
    percentComplete
    hasSubmit
    hasScoring
    hasLiveScoring
    status {
      id
      completed
      completedAt
      completedBy {
        id
        fullName
        firstName
        lastName
        avatar {
          key
        }
        activeAt
      }
      failed
      submitted
      submittedAt
      submittedBy {
        id
        fullName
        firstName
        lastName
        avatar {
          key
        }
        activeAt
      }
      steps {
        ... on CheckboxJobStep {
          id
          responseType
          completed @client
          completedAt
          skip
        }
        ... on DateTimeJobStep {
          id
          responseType
          completed @client
          completedAt
          skip
        }
        ... on FilesJobStep {
          id
          responseType
          completed @client
          completedAt
          skip
        }
        ... on InstructionJobStep {
          id
          responseType
          completed @client
        }
        ... on LongTextJobStep {
          id
          responseType
          completed @client
          completedAt
          skip
        }
        ... on TouchpointJobStep {
          id
          responseType
          completed @client
          completedAt
          skip
        }
        ... on MultipleChoiceJobStep {
          id
          responseType
          completed @client
          completedAt
          skip
        }
        ... on NumberJobStep {
          id
          responseType
          completed @client
          completedAt
          skip
        }
        ... on NumberRatingJobStep {
          id
          responseType
          completed @client
          completedAt
          skip
        }
        ... on PhotosJobStep {
          id
          responseType
          completed @client
          completedAt
          skip
        }
        ... on ProcessJobStep {
          id
          responseType
          completed @client
          completedAt
          skip
          job {
            id
            percentComplete
          }
        }
        ... on SectionJobStep {
          id
          responseType
          completed @client
        }
        ... on SelectionJobStep {
          id
          responseType
          completed @client
          completedAt
          skip
        }
        ... on SignatureJobStep {
          id
          responseType
          completed @client
          completedAt
          skip
        }
        ... on TemperatureTimerJobStep {
          id
          responseType
          completed @client
          completedAt
          skip
        }
        ... on TextJobStep {
          id
          responseType
          completed @client
          completedAt
          skip
        }
      }
      score
      possibleScore
    }
    users {
      id
      fullName
      firstName
      lastName
      avatar {
        key
      }
      activeAt
    }
    groups {
      id
      name
    }
    author {
      id
      fullName
      firstName
      lastName
      avatar {
        key
      }
      activeAt
      groups {
        id
      }
    }
    location {
      id
      name
      timeZone
      subLocations {
        id
        name
      }
    }
    subLocations
    createdAt
    updatedAt
  }
`

const JOB_FIELDS = gql`
  fragment JobFields on Job {
    ...JobListFields
    status {
      id
      steps {
        ...JobStepFields
      }
      startedAt
      endedAt
    }
    tags {
      id
      name
    }
    actionSettings {
      users {
        id
        fullName
      }
      groups {
        id
        name
      }
    }
    responseSetStyles {
      response
      responseSet
      background
    }
  }
  ${JOB_LIST_FIELDS}
  ${JOB_STEP_FIELDS}
`

export { JOB_FIELDS, JOB_LIST_FIELDS }
